module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('article', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('div', {
    attrs: {
      "epub:type": "frontmatter"
    }
  }, [_c('section', {
    attrs: {
      "epub:type": "division"
    }
  }, [_c('div', {
    staticClass: "dis_img",
    attrs: {
      "id": "figvi"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "Images/1-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption11"
  }, [_vm._v("Strollers traverse Manhattan’s Grand Army Plaza, the Hotel New Netherland (opened in 1892–93) prominent in the background. That hotel was replaced in 1927 by the Sherry-Netherland.")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a6723ae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/9781454925767_epub_fm1_r1.vue
// module id = 66
// module chunks = 0